import { RouteGuards } from '../route-guards/route-guards';
import { USER_ROLE_PERMISSIONS_FOR_GUARDS } from '../route-guards/user-role-permissions-for-route-guards.constant';
import { PartnerPickerComponent } from '../../shell/partner-picker/partner-picker.component';

export const shelterPickerRoute = {
  path: 'shelter-picker',
  url: '/shelter-picker',
  rolePermissions: USER_ROLE_PERMISSIONS_FOR_GUARDS['shelter-picker'],
  authenticationRequired: true,
  canActivate: [RouteGuards],
  component: PartnerPickerComponent,
};
